<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12">
        <v-btn-group class="button-with-border">
            <v-btn
              v-for="section in sections"
                :key="section.id"
                @click="selectSection(section.id)"
                :class="{ 'selected-button': selectedSection === section.id }"
                outlined
                :color="section.color"    
                class="button-height"          
              >
              <div class="button-content">
                <div class="button-text">{{ section.text }}</div>
                <img :src="section.icon" alt="icon" class="icon-img" style="width: 40px;" />                
              </div>
          </v-btn>
        </v-btn-group>                     
      </v-col>
    </v-row>
    <v-row v-if="selectedSection === 1">
      <v-col cols="12" md="9">        
        <v-card v-if="isAdmin == 1" style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;">                      
          <v-card-title @click="toggleCollapse" class="d-flex justify-space-between align-center" style="cursor: pointer;">
                <span><v-icon class="mr-2">mdi-plus</v-icon>Post-it</span>
                  <v-icon>{{ isCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                </v-card-title>
                <v-expand-transition>
                  <div v-show="!isCollapsed">
          <v-text-field  variant="solo-filled" v-model="newTitle" label="Title" outlined dense maxlength="30" prepend-inner-icon="mdi-pencil"></v-text-field>
          <QuillEditor class="white-background" v-model="newContent"></QuillEditor>        
          <v-btn
            @click="addPostIt"
            :color="sections[selectedSection-1].color"
            class="mt-4 add-post-btn"
            v-ripple>
            Add Post-It
          </v-btn>
        </div> 
        </v-expand-transition>     
        </v-card>
        <v-card style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;height: 95px;">                    
          <v-text-field
              v-model="filter"
              label="Filter Posts"
              variant="solo-filled"
              class="mb-4"
              prepend-inner-icon="mdi-filter">
            </v-text-field>
        </v-card>
        <div class="board animated-bg2" :style="backgroundImageStyle">  
          <PostIt
            v-for="(post) in filteredPosts"
            :key="post.id"
            :title="post.title"
            :content="post.content"
            :id="post.id"
            :username="post.username"
            :currentUsername="username"
            :color="sections[selectedSection-1].color"
            :isadmin="isAdmin"
            @remove="removePost"
          />
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <v-card style="background-color: #9897A7;padding: 5px;margin-bottom: 20px;border-radius: 20px;">                                      
        <FileUploader :section="selectedSection+10" :currentUsername="username" 
        :addEnable="computedAddEnable" 
        :color="sections[selectedSection-1].color"
        :isadmin="isAdmin"
        />
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" md="8"> 
        <v-alert
          type="info"
          color="#9897A7"
          border="left"
          colored-border
          elevation="3"
          class="mb-4"
          style="border-radius: 20px;"
        >
          <v-card style="background-color: white;padding: 20px;border-radius: 20px;">          
            <p>
              - Questo servizio ha lo scopo di tutelare il collaboratore da eventuali abusi sul posto di lavoro: la segnalazione viene presa in carico dal Comitato Etico che intraprenderà le azioni più idonee entro 96 ore lavorative dalla denuncia. 
              <em>EPHOTO garantisce la riservatezza dell’identità del segnalante e del fatto denunciato.</em><br/>
              <strong>Si ricorda di salvare la UNIQUE ID al fine di poter accedere alla conversazione e controllare la risposta da parte del Comitato Etico.</strong>
            </p>
            <br/>
            <p>
              - This service is intended to protect the employee from workplace abuse: the report is taken up by the Ethics Committee, which will take appropriate action within 96 working hours of the warning.
              <em>EPHOTO guarantees the confidentiality of the identity of the reporter and the fact reported.</em><br/>
              <strong>Please remember to save the UNIQUE ID in order to access the conversation and check the response from the Ethics Committee.</strong>
            </p>
          </v-card>
        </v-alert>
        <v-card style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;height: 180px;">                    

          <p class="mb-2" style="color: white;">Your UNIQUE ID: <strong>{{ conversationId }}</strong></p>

          <v-text-field
            v-model="manualConversationId"
            label="Enter UNIQUE ID: "
            placeholder="Enter existing Conversation ID"
            outlined
            class="white-background"
            style="height: 56px;"
          ></v-text-field>
          
          <v-btn class="mt-4 mr-4" @click="loadConversation" style="width: 200px;">Load Conversation</v-btn>
          <v-btn class="mt-4" @click="generateNewConversationId" style="width: 200px;">New Conversation</v-btn>
        </v-card>
        <v-card style="background-color: #9897A7;padding: 20px;margin-bottom: 20px;border-radius: 20px;height: 315px;">                      
        <textarea
          class=" message-textarea"
          v-model="message"
          placeholder="Write your message here..."
          required
        ></textarea>
        <v-btn @click="sendMessage" :disabled="!message" class="add-post-btn button-background">Send Message</v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <div class="conversation-summary">
          <h2>Submit your abuse warning</h2>
          <ul>
            <li
              v-for="(entry, index) in conversation"
              :key="index"
              @click="loadMessage(entry.message,index)"              
            >
              <div class="conversation-item-content">
                <v-icon v-if="entry.unread" color="green" small class="conversation-item-icon">mdi-circle</v-icon>
                <div class="conversation-item-text">
                  <div>{{ formatDate(entry.timestamp) }}</div>
                  <strong v-if="entry.is_response">Response:</strong>
                  <strong v-else>Message:</strong>
                  <div>{{ truncateMessage(entry.message) }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>

    <!-- Modal -->
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Message Sent</v-card-title>
        <v-card-text>Your abuse report has been taken up
Remember to save the UNIQUE ID and check back on this conversation in 96 business hours to be informed about the actions taken by the Ethics Committee.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import PostIt from './PostIt.vue';
import FileUploader from './FileUploader.vue';
import QuillEditor from './QuillEditor.vue';
import iconPath1 from '@/assets/icone-09.png';
import iconPath2 from '@/assets/icone-10.png';

export default {
  name: 'BCorp',
  components: { PostIt, FileUploader, QuillEditor },
  data() {
    return {
      conversationId: '',
      manualConversationId: '',
      message: '',
      conversation: [],
      dialog: false, // stato per la modal
      sections: [      
        { id: 1, text: 'Info', icon: iconPath1, color: 'white', imageBack: require('@/assets/Iridescent_Light_Spectrum.jpg') },
        { id: 2, text: 'Abuse', icon: iconPath2, color: 'white', imageBack: require('@/assets/Iridescent_Light_Spectrum.jpg') },        
      ],
      newTitle: '',
      newContent: '',
      filter: '',
      posts: [],
      selectedSection: 1, // Sezione inizialmente selezionata
      username: localStorage.getItem('user'), // Ottieni il nome utente dal localStorage
      isAdmin: 0,
      lastUpdate: null, // Per tracciare l'ultimo aggiornamento
      isCollapsed: true,
    };
  },
  computed: {
    computedAddEnable() {
      return this.isAdmin == 1 ? 0 : 1;
    },
    backgroundImageStyle() {
      const selected = this.sections.find(section => section.id === this.selectedSection);
      return selected ? { backgroundImage: `url(${selected.imageBack})` } : {};
    },
    filteredPosts() {
      return this.posts
        .filter(post => post.section === this.selectedSection+10) // Filtra per sezione selezionata
        .filter(post =>
          post.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          post.content.toLowerCase().includes(this.filter.toLowerCase())
        )
        .sort((a, b) => b.timestamp - a.timestamp);
    },
  },
  created() {
    this.isAdmin = localStorage.getItem('isAdmin') || 0;
    this.conversationId = localStorage.getItem('conversationId') || this.generateConversationId();
    localStorage.setItem('conversationId', this.conversationId);
    this.fetchConversation();
    this.startPolling();
    this.loadPosts(); // Carica i post alla creazione del componente
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    truncateMessage(message) {
      if (message.length > 40) {
        return message.substring(0, 40) + '...';
      }
      return message;
    },
    generateConversationId() {
      return Math.random().toString(36).substr(2, 9);
    },
    generateNewConversationId() {
      this.conversationId = this.generateConversationId();
      localStorage.setItem('conversationId', this.conversationId);
      this.conversation = []; // Clear the conversation array
      this.manualConversationId = ''; // Clear the manual conversation ID
    },
    async loadConversation() {
      if (this.manualConversationId) {
        this.conversationId = this.manualConversationId;
        localStorage.setItem('conversationId', this.conversationId);
        await this.fetchConversation();
      }
    },
    async sendMessage() {
      if (!this.message.trim()) return; // Prevent sending empty messages
      const payload = {
        conversationId: this.conversationId,
        message: this.message,
      };
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER3}/send-anonymous-message`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        console.log('Message sent:', data);
        this.message = '';
        this.dialog = true; // Mostra la modal
        await this.fetchConversation();
      } catch (error) {
        console.error('Error:', error);
      }
    },
    async fetchConversation() {
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER3}/conversation/${this.conversationId}`);
        const data = await response.json();
        //this.conversation = data.reverse(); // Inverti l'array per mostrare i messaggi più recenti in cima
        // Aggiungi logica per determinare se un messaggio è stato letto
        // Se è il primo caricamento, segna tutto come letto
        if (!this.lastUpdate) {
          this.conversation = data.reverse().map(entry => {
            entry.unread = false; // Tutti letti inizialmente
            return entry;
          });
        } else {
          // Se c'è stato un aggiornamento, segna solo i nuovi messaggi come non letti
          this.conversation = data.reverse().map(entry => {
            entry.unread = new Date(entry.timestamp) > this.lastUpdate;
            return entry;
          });
        }
        
        // Aggiorna l'ultima data di aggiornamento
        this.lastUpdate = new Date();
      } catch (error) {
        console.error('Error:', error);
      }
    },
    loadMessage(message,index) {
      if(this.conversation[index].unread)
        this.conversation[index].unread = false;     
      else
        this.conversation[index].unread = true;

      this.message = message;
    },
    startPolling() {
      setInterval(() => {
        this.fetchConversation();
      }, 60000); // Update every 60 seconds
    },
    formatDate(timestamp) {
      const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
      return new Date(timestamp).toLocaleDateString('en-US', options);
    },
    selectSection(section) {
      this.selectedSection = section;
      this.loadPosts();
    },
    async addPostIt() {
      if (this.newTitle && this.newContent) {
        const newPost = {
          title: this.newTitle,
          content: this.newContent,
          timestamp: Date.now(),
          section: this.selectedSection+10, // Aggiungi la sezione al nuovo post
          username: this.username, // Aggiungi il nome utente al nuovo post
        };
        console.log('Content: ', this.newContent);
        try {
          const token = localStorage.getItem('token');
          const response = await axios.post(`${process.env.VUE_APP_SERVER3}/posts`, newPost, {
            headers: { Authorization: token },
          });
          this.posts.push(response.data);
          this.newTitle = '';
          this.newContent = '';
        } catch (error) {
          console.error(error);
        }
      }
    },
    async removePost(id) {
      if (confirm('Are you sure you want to delete this post?')) {
        const token = localStorage.getItem('token');
        await axios.delete(`${process.env.VUE_APP_SERVER3}/posts/${id}`, {
          headers: { Authorization: token },
        });
        this.posts = this.posts.filter(post => post.id !== id);
      }
    },
    async loadPosts() {      
      const response = await axios.get(`${process.env.VUE_APP_SERVER3}/posts`, {
        params: { section: this.selectedSection + 10 },
      });
      this.posts = response.data;
    },
  },
  mounted() {
    
    console.log(process.env.VUE_APP_SERVER3);
    console.log('isAdmin:',this.isAdmin);
    this.loadPosts();
  },
};
</script>

<style scoped>
.conversation-item-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.conversation-item-icon {
  margin-right: 10px;
}

.conversation-item-text {
  flex: 1;
}
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 20px;
}
.message-container {
  flex: 1;
  margin-right: 20px;
  text-align: center;
}
.message-textarea {
  padding: 10px;
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  background-color: lightgoldenrodyellow;
  border: 1px solid black;
  box-sizing: border-box;
}
.conversation-summary {
  flex: 1;
  margin-left: 20px;
}

.conversation-summary ul {
  list-style-type: none;
  padding: 0;
}
.conversation-summary li {
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.conversation-summary li:hover {
  background-color: #f0f0f0;
}
.board {
  padding: 20px;
  border-radius: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;  
}
.animated-bg2 {
    animation: slideBackground 15s linear infinite;
  }

/* Keyframe for the sliding background */
@keyframes slideBackground {
  0% { background-position: 0% 50%; }
  50% { background-position: 50% 0%; }
  100% { background-position: 0% 50%; }
}

.white-background {
  background-color: white !important;
}
.selected-button {
  background-color: #d3d3d3 !important; /* Colore di sfondo per il pulsante selezionato */
}
/* Animazioni per le transizioni */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s ease;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* Bottoni con animazioni */
.add-post-btn {
  animation: bounce 1s infinite; /* Effetto di rimbalzo per i bottoni */
  font-size: large;
  color: white !important;
  border-radius: 20px;
  height: 50px;
  width: 300px;  
  background-image: url('@/assets/Iridescent_Light_Spectrum.jpg'); /* Percorso dell'immagine */
  background-size: cover; /* Adatta l'immagine alla dimensione del bottone */
  background-position: center; /* Centra l'immagine nel bottone */
  color: white; /* Colore del testo per contrastare con l'immagine di sfondo */
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Aggiunta di un'animazione di scaling ai bottoni */
.v-btn {
  transition: transform 0.2s;
}
.v-btn:hover {
  transform: scale(1.05);
}
.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 117px;
}
.button-with-border {
  border: 1px solid black !important; /* Bordo nero */
  border-radius: 20px; /* Arrotondamento degli angoli */
  min-height: 80px;  
}

/* Media queries per la visualizzazione mobile */
@media (max-width: 600px) {
  .button-content {
    min-width: 10px !important; /* Riduci la larghezza dei bottoni */
    padding: 0 !important; /* Rimuovi il padding */
  }

  .button-text {
    display: none !important; /* Nascondi il testo */
  }

  .icon-img {
    margin-top: 0 !important; /* Rimuovi lo spazio tra l'icona e il testo */    
  }
}

.button-text {
  white-space: nowrap;
  font-weight: bold;
}
.button-height {
  height: 100%; /* Imposta l'altezza del bottone per corrispondere alla toolbar */
}
.button-background {
  background-image: url('@/assets/Iridescent_Light_Spectrum.jpg'); /* Percorso dell'immagine */
  background-size: cover; /* Adatta l'immagine alla dimensione del bottone */
  background-position: center; /* Centra l'immagine nel bottone */
  color: white; /* Colore del testo per contrastare con l'immagine di sfondo */
}
.add-post-btn {
  animation: bounce 1s infinite;
  font-size: large;
  color: white !important;
  border-radius: 20px;
  height: 50px;
  width: 300px;  
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.selected-button {
  background-color: #9897A7 !important; /* Colore di sfondo per il pulsante selezionato */
}
</style>
